import styled from 'styled-components'
import TypographySecondary from 'components/Typography/Secondary'
import FieldLabel from 'share-ui/components/FieldLabel/FieldLabel'

interface SliderProps {
    value: number
    onChange: (value: number) => void
    min: number
    max: number
    step: number
    name: string
    label?: string
}

const SliderComponent = ({ onChange, value, min, max, step, name, label }: SliderProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(Number(event.target.value))
    }

    return (
        <StyledWrapper>
            <StyledLabelWrapper>
                <FieldLabel labelText={label || name} />
                <TypographySecondary value={value} size='small' semiBold />
            </StyledLabelWrapper>

            <StyledSliderWrapper>
                <StyledSlider
                    type='range'
                    name={name}
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={handleChange}
                />
            </StyledSliderWrapper>
        </StyledWrapper>
    )
}

export default SliderComponent

const StyledWrapper = styled.div``

const StyledSliderWrapper = styled.div`
    padding: 0 5px;
`

const StyledSlider = styled.input`
    cursor: pointer;

    appearance: none;
    -webkit-appearance: none;
    width: 100%;
    height: 4px;
    background: ${({ theme, value, min, max }) => {
        const percentage = ((Number(value) - Number(min)) / (Number(max) - Number(min))) * 100
        return `linear-gradient(
            to right,
            ${theme.body.textColorPrimary} 0%,
            ${theme.body.textColorPrimary} ${percentage}%,
            ${theme.body.backgroundColorSecondary} ${percentage}%,
            ${theme.body.backgroundColorSecondary} 100%
        )`
    }};
    outline: none;
    border: none;
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
        opacity: 1;
    }

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 18px;
        height: 18px;
        background: ${({ theme }) => theme.body.textColorPrimary};
        cursor: pointer;
        border-radius: 50%;
        box-shadow: none;
    }

    &::-moz-range-thumb {
        width: 18px;
        height: 18px;
        background: ${({ theme }) => theme.body.textColorPrimary};
        cursor: pointer;
        border-radius: 50%;
        box-shadow: none;
        border: none;
    }
`

const StyledLabelWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 5px;
`
